import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Location } from '@angular/common';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, CuentaService, BancoService, MonedaService } from '../../shared/services';

import { SearchCuentaRequest, Cuenta, MenuFuncionCodes, GridPageSettings, Banco, SearchBancoRequest, SearchMonedaRequest, Moneda, ExportMediaTypeConstants } from '../../shared/model';

@Component({
    selector: 'app-cuentaList',
    templateUrl: './cuentaList.component.html',
    styleUrls: []
})

export class CuentaListComponent implements OnInit {
    @ViewChild('grid')
    public grid: GridComponent;

    public data: DataManager;
    total: number = 0;
    searchForm: FormGroup;
    
    isSearching: boolean = false;
    isExporting: boolean = false;
    isValidating: boolean = false;
    isBancoSearching: boolean = false;
    isMonedaSearching: boolean = false;

    canAdd: boolean = true;
    canEdit: boolean = true;
    canView: boolean = false;
    canDelete: boolean = true;
    canTenantAdmin: boolean = false;
    verSoloActivos: boolean = true;
    verSoloCuentaCorrienteInterna: boolean;

    public query: Query;
    public bancosList: Banco[]
    public monedasList: Moneda[];

    public selectionOptions: SelectionSettingsModel;
    public pageSizes: number[];
    public toolbarOptions: ToolbarItems[];
    public pageSettings: PageSettingsModel;

    constructor(
        private formBuilder: FormBuilder,
        private location: Location,
        private menuService: MenuFuncionService,
        private bancoService: BancoService,
        private monedaService: MonedaService,
        public dialog: MatDialog,
        private router: Router,
        private sharedFunctions: SharedFunctions,
        private service: CuentaService,
        private datePipe: DatePipe) { 

    }

    ngOnInit(): void {
        this.isValidating = true;
        this.menuService.checkMenuPadre(MenuFuncionCodes.CUENTA).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
                this.menuService.checkMenu(MenuFuncionCodes.TENANT_ADMIN).subscribe(dataTenant => {
                    this.isValidating = false;
                    if (dataTenant != null && dataTenant.Success && dataTenant?.Result)
                        this.canTenantAdmin = true;

                    this.canEdit = data.Result.some(x => x == MenuFuncionCodes.CUENTA_EDIT);
                    this.canAdd = data.Result.some(x => x == MenuFuncionCodes.CUENTA_ADD);
                    this.canView = data.Result.some(x => x == MenuFuncionCodes.CUENTA_LIST);
                    this.canDelete = data.Result.some(x => x == MenuFuncionCodes.CUENTA_DELETE);

                    this.loadView();
                },
                (err: HttpErrorResponse) => {
                    this.sharedFunctions.handleError(err);
                });
            }
            else {
                this.isValidating = false;
                this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                this.onCancel();
            }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    loadView() {
        this.canView = true;
        this.buildForm();

        this.pageSizes = GridPageSettings.PageSizeList;
        this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
        

        this.setQueryParams();
        this.data = new DataManager({
            url: this.service.getSearchUrl(),
            adaptor: new WebApiAdaptor(),
            headers: [this.service.getAuthorizationHeader(), this.service.getTenantHeader()]
        });

        this.getBancos();
        this.getMonedas();
    }

    buildForm() {
        this.searchForm = this.formBuilder.group({
            'BancoId': [null],
            'MonedaId': [null],
            'Alias': [null],
            'ClaveBancaria': [null],
            'Titular': [null],
            'Codigo': [null],
            'VerSoloActivos': [null],
            'VerSoloCuentaCorrienteInterna': [null]
        });
    }

    getBancos() {
        var r = new SearchBancoRequest(null, null, true, "Nombre", null, null, null, true);
        this.isBancoSearching = true;

        this.bancoService.search(r).subscribe(data => {
            this.isBancoSearching = false;
            this.bancosList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isBancoSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    getMonedas() {
        var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
        this.isMonedaSearching = true;

        this.monedaService.search(r).subscribe(data => {
            this.isMonedaSearching = false;
            this.monedasList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isMonedaSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    onSearch() {
        this.setQueryParams();
        this.grid.refresh();
    }

    setQueryParams() {
        if (this.query == null)
            this.query = new Query();

        var index = this.query.params.findIndex(obj => obj.key === "BancoId");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.BancoId;
        else
            this.query.addParams("BancoId", this.searchForm.value.BancoId);

        index = this.query.params.findIndex(obj => obj.key === "MonedaId");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.MonedaId;
        else
            this.query.addParams("MonedaId", this.searchForm.value.MonedaId);

        index = this.query.params.findIndex(obj => obj.key === "Alias");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.Alias;
        else
            this.query.addParams("Alias", this.searchForm.value.Alias);

        index = this.query.params.findIndex(obj => obj.key === "ClaveBancaria");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.ClaveBancaria;
        else
            this.query.addParams("ClaveBancaria", this.searchForm.value.ClaveBancaria);

        index = this.query.params.findIndex(obj => obj.key === "Titular");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.Titular;
        else
            this.query.addParams("Titular", this.searchForm.value.Titular);

        index = this.query.params.findIndex(obj => obj.key === "Codigo");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.Codigo;
        else
            this.query.addParams("Codigo", this.searchForm.value.Codigo);

        index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
        if (index >= 0)
           this.query.params[index].value = this.verSoloActivos ? "true" : "false"; 
        else
           this.query.addParams("VerSoloActivos", this.verSoloActivos ? "true" : "false");

        index = this.query.params.findIndex(obj => obj.key === "VerSoloCuentaCorrienteInterna");
        if (index >= 0)
            this.query.params[index].value = (this.canTenantAdmin ? (this.verSoloCuentaCorrienteInterna ? "true" : "false") : null); 
        else
            this.query.addParams("VerSoloCuentaCorrienteInterna", (this.canTenantAdmin ? (this.verSoloCuentaCorrienteInterna ? "true" : "false") : null));
    }

    add() {
        if (this.canEdit)
            this.router.navigate(['cuenta-edit', 0]);
        else
            this.sharedFunctions.showMessage("No puede ejecutar esta operación", "Error");
    }

    edit(item: Cuenta) {
        if (!item || item.Id == null || item.Id <= 0) {
            this.sharedFunctions.showMessage("Debe seleccionar una cuenta", "Error");
            return false;
        }

        this.router.navigate(['cuenta-edit', item.Id]);
    }

    onExport() {
        var search = new SearchCuentaRequest(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, this.verSoloActivos, (this.canTenantAdmin ? this.verSoloCuentaCorrienteInterna : null), false, null);
        search = Object.assign(search, this.searchForm.value);

        this.isExporting = true;
        this.service.exportSearch(search).subscribe((data: Blob) => {
            this.isExporting = false;
           
            var fileUrl = URL.createObjectURL(data);

            var anchor = document.createElement("a");
            anchor.download = "Cuentas_" + this.datePipe.transform(new Date(), "yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
            anchor.href = fileUrl;
            anchor.click();
        },
        (err: HttpErrorResponse) => {
            this.isExporting = false;
            this.sharedFunctions.handleError(err);
        });
    }

    onCancel() {
        //this.router.navigate(['home']);
        this.location.back();
    }
}
